<template>
  <div
    id="setadmin"
    class="bg-white px-3"
    style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
  >
    <div class="mb-2 mt-2 pt-3">
      <button-search
        ref="buttonSearch"
        placeholder="搜索登录账号"
        @search="searchEvent"
        :showGj="true"
      >
        <!-- 左边 -->
        <template #left>
          <el-button
            class="mr-2"
            v-auth="'addAdmin'"
            @click="openModel(false)"
            type="primary"
            size="mini"
            >添加管理员</el-button
          >
          <el-button
            type="danger"
            v-auth="'delAdmin'"
            @click="deleteAll"
            size="mini"
            >批量删除</el-button
          >
        </template>

        <!-- 高级搜索 -->
        <template #from>
          <el-form inline ref="form" :model="from" label-width="100px">
            <el-form-item label="管理员名称" class="mb-0">
              <el-input
                size="small"
                v-model="from.name"
                placeholder="搜索管理员名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="登录账号" class="mb-0">
              <el-input
                size="small"
                v-model="from.username"
                placeholder="搜索登录账号"
              ></el-input>
            </el-form-item>
            <el-form-item label="登录状态" class="mb-0">
              <el-select
                v-model="from.status"
                size="small"
                placeholder="请选择查看类型"
              >
                <el-option label="全部" :value="-1"></el-option>
                <el-option label="启用" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属角色" class="mb-0">
              <el-select
                v-model="from.rule_id"
                size="small"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in rule_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="创建时间" size="small" class="mb-0">
              <el-date-picker
                v-model="from.time"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item class="mb-0">
              <el-button type="info" @click="searchEvent" size="small"
                >搜索
              </el-button>
              <el-button size="small" @click="clearSearch"
                >清空筛选条件</el-button
              >
            </el-form-item>
          </el-form>
        </template>
      </button-search>
    </div>

    <!-- 表格 -->
    <div class="mt-3 pt-2">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="45" align="center">
        </el-table-column>
        <el-table-column align="center" type="index" label="排序" width="50">
        </el-table-column>
        <!-- <el-table-column align="center" prop="name" label="头像">
					<template slot-scope="scope">
						<el-image 
						    style="width: 40px; height: 40px"
						    :src="scope.row.head" 
						    :preview-src-list="check_img_list">
						  </el-image>
					</template>
				</el-table-column> -->
        <el-table-column align="center" prop="name" label="管理员名称">
        </el-table-column>
        <el-table-column align="center" prop="username" label="登录账号">
        </el-table-column>
        <el-table-column align="center" prop="status" label="登录状态">
          <template slot-scope="scope">
            <el-button
              :type="scope.row.status ? 'success' : 'danger'"
              size="mini"
              @click="changeStatus(scope.row)"
              plain
              >{{ scope.row.status ? "启用" : "禁用" }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="status" label="所属平台">
          <template slot-scope="scope">
            <span
              v-if="
                $store.state.user.platform &&
                $store.state.user.platform.length > 0
              "
              >{{ tabplatformtype(scope.row.platform_type) }}</span
            >
            <span v-else>暂无数据</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="admin_rule.name" label="所属角色">
        </el-table-column>
        <el-table-column align="center" prop="create_time" label="创建时间">
        </el-table-column>
        <el-table-column prop="id" align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                size="mini"
                plain
                type="primary"
                v-auth="'editAdmin'"
                @click="openModel(scope)"
                >编辑</el-button
              >
              <el-button
                @click="deleteItem(scope.row)"
                v-auth="'delAdmin'"
                size="mini"
                plain
                type="danger"
                >删除</el-button
              >
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="height: 60px"></div>
    <el-footer
      class="d-flex border-top bg-white align-items-center px-0 position-fixed"
      style="bottom: 0; left: 200px; right: 0; z-index: 100"
    >
      <!-- 底部 -->

      <div style="flex: 1" class="px-2">
        <el-pagination
          :current-page="page.current"
          :page-sizes="page.sizes"
          :page-size="page.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </el-footer>

    <el-dialog
      :title="editIndex > -1 ? '修改管理员' : '添加管理员'"
      :visible.sync="createModel"
      top="5vh"
    >
      <!-- 表单内容 -->
      <el-form :rules="rules" ref="form" :model="form" label-width="100px">
        <!-- <el-form-item label="头像">
				
					<span v-if="!form.headUrl" class="btn btn-light border" style="padding: 25px 30px;" @click="chooseImage">
						<i class="el-icon-plus" style="font-size: 30px;"></i>
					</span>
					<img v-else @click="chooseImage" :src="form.headUrl" alt="" class="rounded" style="width: 90px;height: auto; cursor: pointer;">
				</el-form-item> -->
        <el-form-item label="管理员名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="管理员名称"
            clearable
            size="small"
            style="width: 34%"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属角色" prop="rule_id">
          <el-select
            v-model="form.rule_id"
            size="small"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in rule_list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="所属平台"
          prop="platform_type"
          v-if="platformtype == 0"
        >
          <el-select
            v-model="form.platform_type"
            size="small"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in $store.state.user.platform"
              :key="item.platform_type"
              :label="item.platform_name"
              :value="item.platform_type"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="登录账号" prop="username">
          <el-input
            v-model="form.username"
            :maxlength="16"
            :minlength="6"
            placeholder="登录账号"
            clearable
            size="small"
            style="width: 34%"
          ></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input
            v-model="form.password"
            :maxlength="16"
            :minlength="6"
            show-password
            placeholder="登录密码"
            size="small"
            style="width: 34%"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password2">
          <el-input
            v-model="form.password2"
            :maxlength="16"
            :minlength="6"
            show-password
            placeholder="确认密码"
            size="small"
            style="width: 34%"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="排序">
			<el-input-number size="small" v-model="form.order" :min="0"></el-input-number>
		</el-form-item> -->
        <el-form-item label="登录状态">
          <el-radio-group v-model="form.status" size="small">
            <el-radio :label="1" border>正常登录</el-radio>
            <el-radio :label="0" border>禁止登录</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="createModel = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import common from "@/common/mixins/common.js";
import buttonSearch from "@/components/common/button-search.vue";
export default {
  components: {
    buttonSearch,
  },
  inject: ["layout"],
  mixins: [common],
  data() {
    return {
      createModel: false,
      editIndex: -1,
      //搜索数据
      from: {
        name: "",
        username: "",
        status: -1,
        rule_id: "",
        time: [],
      },

      preUrl: "user/adminList", //列表地址
      delAllUrl: "user/delAdminAll", //批量删除地址
      delUrl: "user/delAdmin", //删除单条地址
      addUrl: "user/addAdmin", //添加/修改地址
      editStatusUrl: "user/editStatusAdmin", //修改状态地址

      tableData: [],
      form: {
        name: "",
        username: "",
        password: "",
        password2: "",
        headUrl: "",
        status: 1,
        headId: 0,
        rule_id: "",
        platform_type: "",
      },
      // radioplat:[{
      // 	id:1,
      // 	name:"F7平台"
      // },{
      // 	id:2,
      // 	name:"体球平台"
      // },{
      // 	id:3,
      // 	name:"红8平台"
      // },{
      // 	id:4,
      // 	name:"B Sports平台"
      // },{
      // 	id:5,
      // 	name:"新酷玩"
      // }],
      platformtype: "",
      rules: {
        name: [
          {
            required: true,
            message: "管理员名称不能为空",
            trigger: "blur",
          },
        ],
        username: [
          {
            required: true,
            message: "登录账号不能为空",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "管理员名称长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        password: [
          {
            min: 6,
            max: 16,
            message: "密码长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        rule_id: [
          {
            required: true,
            message: "请选择所属角色",
            trigger: "blur",
          },
        ],
        platform_type: [
          {
            required: true,
            message: "请选择所属平台",
            trigger: "blur",
          },
        ],
      },
      rule_list: [],
      check_img_list: [],
    };
  },
  watch: {
    activeName(e) {
      console.log(e);
    },
  },
  created() {
    this.commonList("rule");
  },
  methods: {
    //提交
    submit() {
      if (this.form.password != this.form.password2) {
        this.$message({
          message: "两次密码输入不一致",
          type: "error",
        });
        return;
      }
      this.$refs.form.validate((res) => {
        if (res) {
          //this.form.default = this.form.default.replace(/\n/g,',')
          this.form.id = this.editIndex;
          this.addOrEdit(this.form);
          // 关闭模态框
        }
      });
    },
    // 所属平台
    tabplatformtype(val) {
      if (val != "" && val != null && val != undefined) {
        this.$store.state.user.platform;
        for (let i in this.$store.state.user.platform) {
          if (this.$store.state.user.platform[i].platform_type == val) {
            return this.$store.state.user.platform[i].platform_name;
          }
        }
      } else {
        return "";
      }
    },
    // 打开模态框
    openModel(e = false) {
      // 增加
      if (!e) {
        // 初始化表单
        this.form = {
          name: "",
          username: "",
          password: "",
          password2: "",
          headUrl: "",
          headId: 0,
          status: 1,
          rule_id: "",
          platform_type: "",
        };
        this.editIndex = -1;
      } else {
        // 修改
        this.form = {
          name: e.row.name,
          username: e.row.username,
          password: "",
          password2: "",
          headUrl: e.row.head,
          headId: 0,
          status: e.row.status,
          rule_id: e.row.admin_rule.id,
          platform_type: e.row.platform_type,
        };

        this.editIndex = e.row.id;
      }
      // 打开dialog
      this.createModel = true;
      // 账号等级
      let user = JSON.parse(window.sessionStorage.getItem("user"));
      this.platformtype = user.platform_type;
      // this.form.platform_type = this.platformtype == 1 ? 0 : "";
    },
    //公共列表
    commonList(type) {
      this.layout.loading = true;
      this.api
        .post("/user/commonList", {
          type: type,
        })
        .then((res) => {
          let all = res.data;
          let list = all.data.list;
          this.rule_list = list;

          this.layout.loading = false;
        })
        .catch((err) => {
          // 失败
          this.layout.loading = false;
        });
    },
    //前往修改页面
    editItem(obj) {
      this.$router.push({
        name: "set_manager_rule",
        query: {
          item: obj,
        },
      });
    },
    getListResult(e) {
      this.tableData = e.list;
      this.check_img_list = e.list.map((item) => {
        return item.head;
      });
    },
    // 清空筛选条件
    clearSearch() {
      this.from = {
        name: "",
        username: "",
        status: -1,
        rule_id: "",
        time: [],
        end_time: "",
      };

      this.$refs.buttonSearch.closeSuperSearch();
      this.search = "";
      this.getList();
    },
  },
};
</script>

<style></style>
